import { TextField as MuiTextField } from '@mui/material';
import { useField } from 'formik';

import HelperText from './HelperText';

export default function TextField({ trim, onBlur, onChange, maxLength, margin = 'normal', required, preventPaste, endAdornment, predicted = undefined, ...props }) {
	const [field, meta, helper] = useField(props.name);
	let filterValue = undefined;

	if (props.filterState) {
		const filterMap = {
			Start: props.filterState.minValue,
			End: props.filterState.maxValue
		};

		filterValue = filterMap[props.placeholder] || props.filterState.value;
	}

	const handleChange = event => {
		helper.setTouched(true);
		const value = trim ? event.target.value.trim() : event.target.value;
		if (onChange) onChange(value, field, helper);
		helper.setValue(value);
	};

	const handleBlur = event => {
		if (onBlur) onBlur(event, field, helper);

		field.onBlur(event);
	};

	return (
		<MuiTextField
			{...props}
			fullWidth
			data-cy={props.label}
			margin={margin}
			value={props.filterState ? filterValue : (field.value ?? '')}
			error={!!meta.error}
			sx={{
				'& .MuiOutlinedInput-notchedOutline': {
					...(predicted && field.value == predicted ? { borderColor: 'common.warning' } : {})
				}
			}}
			onChange={handleChange}
			onBlur={handleBlur}
			required={required}
			helperText={<HelperText meta={meta} required={required} maxLength={maxLength} helperText={props.helperText} />}
			InputProps={{ className: 'field', maxLength, endAdornment }}
			onPaste={preventPaste ? event => event.preventDefault() : undefined}
		/>
	);
}
